// hooks/useSwipe.ts
import { useState } from 'react';
import { useAppDispatch } from '../store/hooks';
import { incrementCategory, decrementCategory } from '../store/navigationSlice';

export const useSwipe = () => {
    // console.log("useSwipe called")
  const dispatch = useAppDispatch();
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  const minSwipeDistance = 100;

  const onTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      dispatch(incrementCategory());   
    } else if (isRightSwipe) {
      dispatch(decrementCategory());   
    }
  };

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd
  };
};